import { useNavigate, useParams } from "react-router-dom";
import { useGetTransactionById } from "../../../features/transaction";
import { safeDateFormat } from "../../../utils/saveDateFormat";
import { FiChevronLeft } from "react-icons/fi";

// Komponen untuk menampilkan card log
const LogCard = ({ log }: { log: any }) => {
  return (
    <div className="bg-white p-4 border border-gray-300 rounded-lg shadow-md mb-4">
      <div className="flex justify-between gap-3 items-center mb-2">
        <h3 className="text-base font-semibold text-gray-800 w-80">
          {log.message}
        </h3>
        <span
          className={`text-xs font-semibold text-${
            log.status === "PENDING" ? "yellow" : "green"
          }-600`}
        >
          {log.status}
        </span>
      </div>
      <p className="text-xs text-gray-600">
        <span className="font-normal">Source:</span> {log.source}
      </p>
      <p className="text-xs text-gray-500">
        <span className="font-normal">Created At:</span>{" "}
        {safeDateFormat(log.createdAt, true)}
      </p>
    </div>
  );
};

const PageLogs = () => {
  const { id } = useParams<{ id: string }>();
  const { transaction: transactionId } = useGetTransactionById(id);
  const router = useNavigate();

  return (
    <div className="p-6 max-w-4xl mx-auto bg-white border-t-4">
      {/* Header */}
      <div className="relative flex items-center justify-center mb-6">
        <button className="absolute left-0">
          <FiChevronLeft
            className="w-5 h-5 text-gray-500"
            onClick={() => router(-1)}
          />
        </button>
        <h2 className="text-base font-semibold text-gray-800">Detail</h2>
      </div>

      {/* Display Logs */}
      <div className="mt-6">
        {transactionId?.transactionLogs?.map((log: any) => (
          <LogCard key={log.id} log={log} />
        ))}
      </div>
    </div>
  );
};

export default PageLogs;
